/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFileStack = createReactComponent("outline", "file-stack", "IconFileStack", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M5 21h14", "key": "svg-2" }], ["path", { "d": "M5 18h14", "key": "svg-3" }], ["path", { "d": "M5 15h14", "key": "svg-4" }]]);

export { IconFileStack as default };
//# sourceMappingURL=IconFileStack.mjs.map
